import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, UtensilsCrossed, BedDouble, Anchor, PartyPopper } from "lucide-react";
import { publicApi } from "@/lib/api";
import { PropertyCard, Loader, PageHeader } from "@/components/public/ui";

const SECTIONS = [
  { key: "dine", label: "Dine", icon: UtensilsCrossed, cta: "Explore Dining",
    copy: "From prime steaks to just-caught seafood, our restaurants celebrate seasonal Coastal Virginia cooking — most with a view of the water." },
  { key: "stay", label: "Stay", icon: BedDouble, cta: "Find Your Stay",
    copy: "Boutique inns, cottages and waterfront accommodations for weekend escapes and unhurried getaways." },
  { key: "dock", label: "Dock", icon: Anchor, cta: "Explore Our Marinas",
    copy: "Full-service marinas and waterfront access points that welcome boaters throughout the region." },
  { key: "gather", label: "Gather", icon: PartyPopper, cta: "Plan an Event",
    copy: "Weddings, private dining, corporate gatherings and celebrations in memorable waterfront settings." },
];

export default function Experiences() {
  const [properties, setProperties] = useState(null);
  useEffect(() => { publicApi.get("/properties").then((r) => setProperties(r.data)).catch(() => setProperties([])); }, []);

  return (
    <div className="pt-20">
      <PageHeader eyebrow="Experiences" title={<>More Ways to Experience Coastal Virginia</>}
        intro="From the table to the water, discover every way to spend a day across the Pack Brothers collection." />

      {properties === null ? <div className="py-20"><Loader /></div> : SECTIONS.map((s, i) => {
        const matches = properties.filter((p) => (p.categories || []).includes(s.key)).slice(0, 3);
        return (
          <section key={s.key} className={i % 2 === 1 ? "bg-[#F5F3EF] py-20" : "py-20"}>
            <div className="mx-auto max-w-[1280px] px-5 lg:px-8">
              <div className="mb-10 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
                <div className="max-w-2xl">
                  <s.icon className="mb-3 h-8 w-8 text-[#526E7E]" />
                  <h2 className="font-serif text-[36px] leading-tight text-[#18344A]">{s.label}</h2>
                  <p className="mt-3 text-[15px] leading-relaxed text-[rgba(48,56,60,0.72)]">{s.copy}</p>
                </div>
                <Link to={`/portfolio?category=${s.key}`} className="inline-flex items-center gap-2 rounded-full bg-[#18344A] px-6 py-3 text-sm font-semibold uppercase tracking-[0.06em] text-white hover:bg-[#18344A]/90">
                  {s.cta} <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
              {matches.length > 0 && (
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">{matches.map((p) => <PropertyCard key={p.id} p={p} />)}</div>
              )}
            </div>
          </section>
        );
      })}
    </div>
  );
}
